import type { AppType } from "@repo/backend";
import { hc } from "hono/client";

/**
 * API URL (HTTP)
 */
export const API_URL = import.meta.env.VITE_API_URL || "http://localhost:9787";

/**
 * Hono RPC クライアント
 * バックエンド API を型安全に呼び出すためのクライアント
 */
export const apiClient = hc<AppType>(API_URL, {
  // Cookieを送信するために必要
  fetch: (input: RequestInfo | URL, init?: RequestInit) =>
    fetch(input, {
      ...init,
      credentials: "include",
    }),
});
